<template>
  <div id="entTable">
    <Head />
    <div class="table">
      <div class="position">
        <img src="../../assets/public/8.png" /> 当前位置:
        <router-link to="/">首页</router-link>>
        <router-link to="/#biaogan">标杆企业</router-link>>企业名录
      </div>
      <div class="tMain">
        <h3>企业名录</h3>

        <table>
          <tr>
            <th style="background: #109AFA;">央企/省份</th>
            <th style="background: #FA8410;">公司名称</th>
            <th style="background: #FA1063;">子/分公司名称</th>
          </tr>
          <tr v-for="(items,indexs) in arrS" :key="indexs">
            <td
              v-for="(item,index) in items"
              :key="index"
              :class="{A : item.i == 0, B : item.i == 1,C : item.i == 2}"
              :rowspan="getRow(item.i,indexs)"
            >{{item.name}}</td>
          </tr>
          <tr>
            <td rowspan="8" class="A">北京</td>
            <td class="B">华电煤业集团有限公司</td>
            <td class="C"></td>
          </tr>
          <tr>
            <td rowspan="3" class="B">北京能源集团有限责任公司</td>
            <td rowspan="2" class="C">北京昊华能源股份有限公司</td>
          </tr>
          <tr>
            <!-- <td class="C"></td> -->
          </tr>
          <tr>
            <!-- <td class="C"></td> -->
          </tr>
          <tr>
            <td rowspan="4" class="B">华能煤业有限公司</td>
            <td class="C">华能呼伦贝尔能源开发有限公司</td>
          </tr>
          <tr>
            <td class="C">华能伊敏煤电有限责任公司</td>
          </tr>
          <tr>
            <td class="C">华亭煤业集团有限责任公司</td>
          </tr>
          <tr>
            <!-- <td class="C"></td> -->
          </tr>
          <tr>
            <td rowspan="11" class="A">河北</td>
            <td rowspan="2" class="B">开滦（集团）有限责任公司</td>
            <td class="C">开滦能源化工股份有限公司</td>
          </tr>
          <tr>
            <!-- <td class="C"></td> -->
          </tr>
          <tr>
            <td rowspan="9" class="B">冀中能源集团有限责任公司</td>
            <td class="C">冀中能源股份有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源峰峰集团有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源邯郸矿业集团有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源邢台矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源张家口矿业集团有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源井陉矿业集团有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源机械装备集团有限公司</td>
          </tr>
          <tr>
            <td class="C">冀中能源国际物流集团有限公司</td>
          </tr>
          <tr>
            <td class="C">华北医疗健康产业集团有限公司</td>
          </tr>
          <tr>
            <td rowspan="12" class="A">山西</td>
            <td rowspan="2" class="B">大同煤矿集团有限责任公司</td>
            <td class="C">大同煤业股份有限公司</td>
          </tr>
          <tr>
            <!-- <td class="C"></td> -->
          </tr>
          <tr>
            <td rowspan="4" class="B">山西焦煤集团有限责任公司</td>
            <td class="C">西山煤电（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">霍州煤电集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">汾西矿业（集团）有限责任公司</td>
          </tr>
          <tr>
            <!-- <td></td> -->
          </tr>
          <tr>
            <td class="B">阳泉煤业（集团）有限责任公司</td>
            <td class="C"></td>
          </tr>
          <tr>
            <td class="B">山西晋城无烟煤矿业集团有限责任公司</td>
            <td class="C">晋城蓝焰煤业股份有限公司</td>
          </tr>
          <tr>
            <td class="B">山西潞安矿业（集团）有限责任公司</td>
            <td class="C">山西潞安环保能源开发股份有限公司</td>
          </tr>
          <tr>
            <td class="B">晋能集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">山西煤炭进出口集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">中国（太原）煤炭交易中心</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="7" class="A">内蒙古</td>
            <td class="B">内蒙古伊泰集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">内蒙古伊东资源集团股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">内蒙古汇能煤电集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">内蒙古蒙泰煤电集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">满世投资集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">内蒙古特弘煤电集团有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">鄂尔多斯市乌兰煤炭（集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4" class="A">辽宁</td>
            <td class="B">辽宁铁法能源有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">沈阳煤业（集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">阜新矿业（集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">抚顺矿业集团有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td rowspan="4" class="A">吉林</td>
            <td rowspan="4" class="B">吉林省煤业集团有限公司</td>
            <td class="C">辽源矿业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">通化矿业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">珲春矿业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">舒兰矿业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td rowspan="4" class="A">黑龙江</td>
            <td rowspan="4" class="B">黑龙江龙煤矿业控股集团有限责任公司</td>
            <td class="C">黑龙江龙煤七台河矿业有限责任公司</td>
          </tr>
          <tr>
            <td class="C">黑龙江龙煤双鸭山矿业有限责任公司</td>
          </tr>
          <tr>
            <td class="C">黑龙江龙煤鸡西矿业有限责任公司</td>
          </tr>
          <tr>
            <td class="C">黑龙江龙煤鹤岗矿业有限责任公司</td>
          </tr>
          <tr>
            <td class="A">江苏</td>
            <td class="B">徐州矿务集团有限公司</td>
            <td class="C"></td>
          </tr>
          <tr>
            <td class="A">浙江</td>
            <td class="B">浙江省能源集团有限公司</td>
            <td class="C"></td>
          </tr>
          <tr>
            <td rowspan="5" class="A">安徽</td>
            <td class="B">淮河能源控股集团有限责任公司</td>
            <!-- <td  class="B">淮河能源控股集团有限责任公司</td> -->
            <td class="C"></td>
          </tr>
          <tr>
            <td class="B">淮北矿业（集团）有限责任公司</td>
            <td class="C">淮北矿业股份有限公司</td>
          </tr>
          <tr>
            <td class="B">安徽省皖北煤电集团有限责任公司</td>
            <td class="C">安徽恒源煤电股份有限公司</td>
          </tr>
          <tr>
            <td class="B">中煤第三建设(集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">中煤矿山建设集团有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">福建</td>
            <td class="B">福建省能源集团有限责任公司</td>
            <td class="C"></td>
          </tr>
          <tr>
            <td rowspan="2" class="A">江西</td>
            <td rowspan="2" class="B">江西省投资集团有限公司</td>
            <td class="C">萍乡矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">江西丰矿集团有限公司</td>
          </tr>
          <tr>
            <td rowspan="23" class="A">山东</td>
            <td rowspan="13" class="B">山东能源集团有限公司</td>
            <td class="C">新汶矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">枣庄矿业(集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">淄博矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">临沂矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">肥城矿业集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">龙口矿业集团有限公司</td>
          </tr>
          <tr>
            <td class="C">山东能源集团财务有限公司</td>
          </tr>
          <tr>
            <td class="C">山东能源集团贵州矿业有限公司</td>
          </tr>
          <tr>
            <td class="C">山东能源重型装备制造集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">山东能源国际贸易有限公司</td>
          </tr>
          <tr>
            <td class="C">山东能源医疗健康投资有限公司</td>
          </tr>
          <tr>
            <td class="C">山东能源置业集团有限公司</td>
          </tr>
          <tr>
            <td class="C">内蒙古盛鲁能化有限公司</td>
          </tr>
          <tr>
            <td rowspan="3" class="B">兖矿集团有限公司</td>
            <td class="C">兖州煤业股份有限公司</td>
          </tr>
          <tr>
            <td class="C">兖煤菏泽能化有限公司</td>
          </tr>
          <tr>
            <td class="C">山东华聚能源股份有限公司</td>
          </tr>
          <tr>
            <td class="B">济宁能源发展集团有限公司</td>
            <td class="C">济宁矿业集团有限公司</td>
          </tr>
          <tr>
            <td class="B">山东矿机集团股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">山东裕隆矿业集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">山东华宁矿业集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">济宁高科股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">山东泰丰控股集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">山东鲁泰煤业集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A" rowspan="15">河南</td>
            <td class="B">中国平煤神马能源化工集团有限责任公司</td>
            <td class="C">平顶山天安煤业股份有限公司</td>
          </tr>
          <tr>
            <td class="B" rowspan="10">河南能源化工集团有限公司</td>
            <td class="C">永城煤电控股集团有限公司</td>
          </tr>
          <tr>
            <td class="C">焦作煤业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">鹤壁煤业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">义马煤业集团股份有限公司</td>
          </tr>
          <tr>
            <td class="C">河南能源化工国际贸易集团有限公司</td>
          </tr>
          <tr>
            <td class="C">河南能源中原大化集团有限责任公司</td>
          </tr>
          <tr>
            <td class="C">河南龙宇煤化工有限公司</td>
          </tr>
          <tr>
            <td class="C">河南能源化工集团重型装备有限公司</td>
          </tr>
          <tr>
            <td class="C">河南省煤气（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">河南能源化工集团新疆投资控股有限公司</td>
          </tr>
          <tr>
            <td class="B">郑州煤炭工业（集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">郑州煤矿机械集团股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">河南神火煤电股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">郑州市磴槽集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">湖南</td>
            <td class="B">湖南省煤业集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">广西</td>
            <td class="B">百色百矿集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">重庆</td>
            <td class="B">重庆市能源投资集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A" rowspan="8">四川</td>
            <td class="B" rowspan="5">四川省煤炭产业集团有限责任公司</td>
            <td class="C">四川华蓥山广能（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">四川达竹煤电（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">攀枝花煤业（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="C">四川芙蓉集团实业有限责任公司</td>
          </tr>
          <tr>
            <td class="C">四川广旺能源发展（集团）有限责任公司</td>
          </tr>
          <tr>
            <td class="B">四川省古叙煤田开发股份有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">四川嘉阳集团有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="B">四川省煤田地质局</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">贵州</td>
            <td class="B">贵州盘江煤电集团有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A" rowspan="2">陕西</td>
            <td class="B">陕西煤业化工集团有限责任公司</td>
            <td class="C">陕西煤业股份有限公司</td>
          </tr>
          <tr>
            <td class="B">陕西榆林能源集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">甘肃</td>
            <td class="B">甘肃能源化工投资集团有限公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">青海</td>
            <td class="B">青海省能源发展（集团）有限责任公司</td>
            <td></td>
          </tr>
          <tr>
            <td class="A">新疆</td>
            <td class="B">新疆焦煤（集团）有限责任公司</td>
            <td></td>
          </tr>
        </table>
        <!-- <el-table
          :data="tableData"
          :span-method="colspanMethod"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="name" label="国企/省份" width="180"></el-table-column>
          <el-table-column prop="item" label="一级公司"></el-table-column>
          <el-table-column prop="itme1" label="二级公司">
            <template slot-scope="scope">{{scope.row.jyFile.item1}}</template>
          </el-table-column>
        </el-table>-->
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Foot from "../../components/Foot";
import Head from "../../components/Head";
export default {
  name: "entTable",
  mounted() {
    let arr = this.enterprise;
    let arrS = [];
    let key = {};
    for (let i = 0; i < arr.length; i++) {
      let len = 0;
      let s;
      for (let j = 0; j < arr[i].item.length; j++) {
        len += arr[i].item[j].item.length;
        for (let m = 0; m < arr[i].item[j].item.length; m++) {
          if (m == 0 && j == 0) {
            s = arrS.length;
            key["0" + s] = arr[i].item[j].item.length;
            arrS.push([
              { name: arr[i].name, i: 0 },
              { name: arr[i].item[j].name, i: 1 },
              { name: arr[i].item[j].item[m], i: 2 }
            ]);
          } else if (m == 0 && j > 0) {
            s = arrS.length;
            key["0" + s] = arr[i].item[j].item.length;
            arrS.push([
              { name: arr[i].item[j].name, i: 1 },
              { name: arr[i].item[j].item[m], i: 2 }
            ]);
          } else {
            arrS.push([{ name: arr[i].item[j].item[m], i: 2 }]);
          }
        }
      }
      key[s] = len;
    }
    this.arrS = arrS;

    this.key = key;
    // let  arr=this.tableList;
    // var ji=0;
    // // let yijichangdu=[];
    // // let erjichangdu=[];
    // let list=[];
    // let that=this;

    // for(let i=0,len=arr.length;i<len;i++){
    //   for(let key in arr[i]){
    //     if(key=="company"){
    //       console.log(arr[i].company)
    //       for(let j=0,chang=arr[i].company.length;j<chang;j++){
    //         that.arr = Object.assign(that.arr, that.toObj2(arr[i].company[j].company1, arr[i].company[j].corporation.length));
    //         // erjichangdu.push(arr[i].company[j].corporation.length)
    //         // list.push(arr[i].company[j].corporation)
    //         arr[i].company[j].corporation.forEach(val=>{
    //             list.push(`<tr><td>${val}</td></tr>`)
    //         })

    //         ji+=arr[i].company[j].corporation.length
    //         // yijichangdu.push(ji)

    //       }

    //       // for(let j=0,chang=key.length;j<chang;j++){
    //       //    ji+=key[j].corporation.length
    //       // }

    //     }
    // html+=`<td rowspan=${ji}>${arr[i].city}</td>`
    //   }
    //   that.arr1 = Object.assign(that.arr1, that.toObj2(arr[i].city, ji));
    // }
    // list.forEach(function(val,index){
    // //循环遍历 this.arr一级公司对象
    //   for(let key1 in that.arr){
    //    console.log( list[0][3],val,index,key1)
    //   }
    // })
    // console.log(this.arr)
    // console.log(this.arr1)
    // console.log(list)
  },
  data() {
    return {
      arr: {},
      arr1: {},
      leng: 0,
      arrS: [],
      key: {},
      spanArr: [],
      // tableList: [
      //   {
      //     city: "北京",
      //     company: [
      //       {
      //         company1: "华电煤业集团有限公司",
      //         corporation: ["华电煤业集团有限公司"]
      //       },
      //       {
      //         company1: "北京能源集团有限责任公司",
      //         corporation: [
      //           "北京能源集团有限责任公司",
      //           "北京昊华能源股份有限公司"
      //         ]
      //       },
      //       {
      //         company1: "华能煤业有限公司",
      //         corporation: [
      //           "华能煤业有限公司",
      //           "华能呼伦贝尔能源开发有限公司",
      //           "华能伊敏煤电有限责任公司",
      //           "华亭煤业集团有限责任公司"
      //         ]
      //       }

      //     ]
      //   },

      // ]
      // tableData: [
      //   {
      //     name: "国家能源投资集团",
      //     item: "国家能源投资集团有限责任公司",
      //     item1: [
      //       "国家能源投资集团有限责任公司",
      //       "神华神东煤炭集团有限责任公司",
      //       "神华准能集团有限责任公司",
      //       "国家能源集团宁夏煤业有限责任公司",
      //       "神华包头能源有限责任公司",
      //       "神华榆林能源化工有限公司",
      //       "中国神华煤制油化工有限公司",
      //       "内蒙古平庄煤业（集团）有限责任公司",
      //       "神华宝日希勒能源有限公司",
      //       "内蒙古大雁矿业集团有限责任公司"
      //     ]
      //   },
      //   {
      //     name: "中国中煤能源集团",
      //     item: [
      //       {
      //         name: "中国中煤能源集团有限公司",
      //         item: [
      //           "中国中煤能源集团有限公司",
      //           "上海大屯能源股份有限公司",
      //           "中煤平朔集团有限公司",
      //           "中煤新集能源股份有限公司",
      //           "国投煤炭有限公司",
      //           "中煤第一建设有限公司",
      //           "中国煤矿机械装备有限责任公司",
      //           "中煤北京煤矿机械有限责任公司",
      //           "中煤电气有限公司",
      //           "中煤张家口煤矿机械有限责任公司",
      //           "石家庄煤矿机械有限责任公司",
      //           "中煤西北能源有限公司",
      //           "平朔工业集团有限责任公司",
      //           "陕西南梁矿业有限公司",
      //           "中煤信息技术（北京）有限公司",
      //           "中天合创能源有限责任公司",
      //           "中煤建设集团有限公司"
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     name: "中国煤炭科工集团",
      //     item: [
      //       {
      //         name: "中国煤炭科工集团有限公司",
      //         item: [
      //           "中国煤炭科工集团有限公司",
      //           "天地科技股份有限公司",
      //           "中煤科工集团北京华宇工程有限公司",
      //           "煤炭科学技术研究院有限公司",
      //           "中煤科工集团沈阳设计研究院有限公司",
      //           "中煤科工集团上海有限公司",
      //           "中煤科工集团西安研究院有限公司",
      //           "中煤科工集团重庆研究院有限公司",
      //           "中国煤炭科工集团太原研究院有限公司",
      //           "天地（常州）自动化股份有限公司",
      //           "煤炭工业规划设计研究院有限公司"
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     name: "中国煤炭地质总局",
      //     item: [
      //       {
      //         name: "中国煤炭地质总局",
      //         item: [
      //           "中国煤炭地质总局",
      //           "中能化创新投资管理有限公司",
      //           "中煤航测遥感集团有限公司",
      //           "中国煤炭地质总局第一勘探局"
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     name: "北京",
      //     item: [
      //       "华电煤业集团有限公司",
      //       "北京能源集团有限责任公司",
      //       "华能煤业有限公司"
      //     ],
      //     item1: [
      //       "华电煤业集团有限公司",
      //       "北京能源集团有限责任公司",
      //       "北京昊华能源股份有限公司",
      //       "华能煤业有限公司",
      //       "华能呼伦贝尔能源开发有限公司",
      //       "华能伊敏煤电有限责任公司",
      //       "华亭煤业集团有限责任公司"
      //     ]
      //   }
      // ]
      enterprise: [
        {
          name: "国家能源投资集团",
          item: [
            {
              name: "国家能源投资集团有限责任公司",
              item: [
                "神华神东煤炭集团有限责任公司",
                "神华准能集团有限责任公司",
                "国家能源集团宁夏煤业有限责任公司",
                "神华包头能源有限责任公司",
                "神华榆林能源化工有限公司",
                "中国神华煤制油化工有限公司",
                "内蒙古平庄煤业（集团）有限责任公司",
                "神华宝日希勒能源有限公司",
                "内蒙古大雁矿业集团有限责任公司"
              ]
            }
          ]
        },
        {
          name: "中国中煤能源集团",
          item: [
            {
              name: "中国中煤能源集团有限公司",
              item: [
                "上海大屯能源股份有限公司",
                "中煤平朔集团有限公司",
                "中煤新集能源股份有限公司",
                "国投煤炭有限公司",
                "中煤第一建设有限公司",
                "中国煤矿机械装备有限责任公司",
                "中煤北京煤矿机械有限责任公司",
                "中煤电气有限公司",
                "中煤张家口煤矿机械有限责任公司",
                "石家庄煤矿机械有限责任公司",
                "中煤西北能源有限公司",
                "平朔工业集团有限责任公司",
                "陕西南梁矿业有限公司",
                "中煤信息技术（北京）有限公司",
                "中天合创能源有限责任公司",
                "中煤建设集团有限公司"
              ]
            }
          ]
        },
        {
          name: "中国煤炭科工集团",
          item: [
            {
              name: "中国煤炭科工集团有限公司",
              item: [
                "天地科技股份有限公司",
                "中煤科工集团北京华宇工程有限公司",
                "煤炭科学技术研究院有限公司",
                "中煤科工集团沈阳设计研究院有限公司",
                "中煤科工集团上海有限公司",
                "中煤科工集团西安研究院有限公司",
                "中煤科工集团重庆研究院有限公司",
                "中国煤炭科工集团太原研究院有限公司",
                "天地（常州）自动化股份有限公司",
                "煤炭工业规划设计研究院有限公司"
              ]
            }
          ]
        },
        {
          name: "中国煤炭地质总局",
          item: [
            {
              name: "中国煤炭地质总局",
              item: [
                "中能化创新投资管理有限公司",
                "中煤航测遥感集团有限公司",
                "中国煤炭地质总局第一勘探局"
              ]
            }
          ]
        }
        // {
        //   name: "北京",
        //   item: [
        //     {
        //       name: [
        //         "华电煤业集团有限公司",
        //         "北京能源集团有限责任公司",
        //         "华能煤业有限公司"
        //       ],
        //       item: [
        //         "华电煤业集团有限公司",
        //         "北京能源集团有限责任公司",
        //         "北京昊华能源股份有限公司",
        //         "华能煤业有限公司",
        //         "华能呼伦贝尔能源开发有限公司",
        //         "华能伊敏煤电有限责任公司",
        //         "华亭煤业集团有限责任公司"
        //       ]
        //     }
        //   ]
        // }
      ]
    };
  },
  methods: {
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    getRow(i, s) {
      var key = this.key;
      if (i == 0) {
        return key[s];
      } else if (i == 1) {
        return key["0" + s];
      } else {
        return 1;
      }
    }
  },
  components: {
    Foot,
    Head
  }
};
</script>
<style >

</style>
<style lang="less" scoped>
#entTable {
  font-size: 0.16rem;
  width: 100%;
  min-width: 1000px;
  .table {
  
    width: 100%;
    margin-top: 0.4rem;
    padding: 0 1.35rem;
    .position {
      display: flex;
      align-items: center;
      padding: 0.1rem;
      background: #f1f1f1;
      color: #2f4f73;
      img {
        width: 0.2rem;
        margin-right: 0.1rem;
      }
    }
    .tMain {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0.2rem;
      table {
        margin-top: 0.2rem;
        border-collapse: collapse;
        th {
          width: 4rem;
          color: #fff;
          height: 0.35rem;
           border: 0.01rem solid #000;
        }
        td {
          text-align: center;
          border: 0.01rem solid #000;
          height: 0.4rem;
          &.A {
            font-size: 0.22rem;
            &:hover {
              background: #109afa;
              color: #ffffff;
            }
          }
          &.B {
            font-size: 0.2rem;
            &:hover {
              background: #fa8410;
              color: #ffffff;
            }
          }
          &.C {
            font-size: 0.18rem;
            &:hover {
              background: #fa1063;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>